/**
 * @fileoverview GET handler for the "/engagement/link_templates/territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkTemplatesTerritories } from "./constants";
import type { EngagementLinkTemplatesTerritoriesResult } from "./types";

export const getEngagementLinkTemplatesTerritories = reactQueryFetcherAdapter(
  engagementLinkTemplatesTerritories,
  (signal: AbortSignal): Promise<EngagementLinkTemplatesTerritoriesResult> => {
    return fetch("/engagement/link_templates/territories", "GET", {}, { signal });
  }
);
